import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonToolbar,
  Form,
  Loader,
  Container,
  Content,
  Checkbox,
  Modal,
} from "rsuite";
import { UserServices } from "../../../core/services/UserServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import "./Users.css";
import { useSelector } from "react-redux";
import {
  genderObjArr,
  onOffArr,
  religionObjArr,
} from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import {
  displayField,
  downloadImage,
  getLabelFor,
} from "../../../utils/helpers";
import { Link } from "react-router-dom";

const ViewProfileModal = (props: any) => {
  const { t } = useTranslation();
  const userActionData = useSelector((state: any) => {
    return state?.actionData?.id;
  });
  const [loader, setLoader] = useState(false);
  const [userInfo, setUserInfo] = useState<any>({});
  const [address, setAddress] = useState<any>({});
  async function getViewUserDetail(id: number) {
    try {
      setLoader(true);
      const res = await UserServices.viewUser(id);
      setLoader(false);
      if (res && res.data && res.data.data) {
        setUserInfo({ ...res.data.data });
        if (res.data.data.addresses.length) {
          res.data.data.addresses.map((item: any) => {
            if (item?.is_primary_address === "1") {
              setAddress(item);
            }
          });
        }
      }
    } catch (error) {
      setLoader(false);
    }
  }
  useEffect(() => {
    let userId = userActionData
      ? userActionData
      : UtilityServices.getLoggedInUser("id");
    getViewUserDetail(userId);
  }, []);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={props.status}
        backdrop={false}
        onClose={(e: any) => {
          props.toggle("");
        }}
      >
        <Modal.Header>
          <h4 className="text-center">
            {t("VIEW")} {t("DETAIL")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="users view-users">
            <Container className="container">
              {userInfo && Object.keys(userInfo).length ? (
                <Content>
                  <Form layout="inline">
                    <div className="view-usr-profile text-center mb-2">
                      <div>
                        <img
                          src={
                            userInfo && userInfo?.image_url
                              ? userInfo.image_url
                              : UtilityServices.getLoggedInUser(
                                  "user_default_image"
                                )
                          }
                          alt=""
                        />
                      </div>
                    </div>
                    <Form.Group controlId="fname">
                      <Form.ControlLabel>
                        {t("FIRST_NAME")} :{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${userInfo?.fname}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="lname">
                      <Form.ControlLabel>{t("LAST_NAME")}</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${userInfo?.lname}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="email">
                      <Form.ControlLabel>{t("EMAIL")}</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${userInfo?.email}`)}{" "}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="mobile">
                      <Form.ControlLabel>{t("MOBILE")}</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${userInfo?.mobile}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="fname">
                      <Form.ControlLabel>
                        {t("ID")} {t("PROOF")} :{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {userInfo?.user_id_proof_doc_url ? (
                          <Button
                            onClick={() =>
                              downloadImage(
                                userInfo?.user_id_proof_doc_url,
                                userInfo?.user_id_proof_doc
                              )
                            }
                            className="btn"
                            appearance="primary"
                          >
                            {t("DOWNLOAD")}
                          </Button>
                        ) : (
                          displayField(`${userInfo?.user_id_proof_doc_url}`)
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="username">
                      <Form.ControlLabel>{t("USERNAME")} : </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${userInfo?.username}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="role_id">
                      <Form.ControlLabel>{t("ROLE")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${userInfo?.roles[0]?.label}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="store_id">
                      <Form.ControlLabel>
                        {t("STORE")} {t("NAME")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${userInfo?.store?.store_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="emp_code">
                      <Form.ControlLabel>
                        {t("EMPLOYEE_CODE")} :{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${userInfo?.emp_code}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="designation">
                      <Form.ControlLabel>
                        {t("DESIGNATION")} :{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${userInfo?.designation}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="gender">
                      <Form.ControlLabel>{t("GENDER")} : </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          getLabelFor(userInfo?.gender, genderObjArr)
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="religion">
                      <Form.ControlLabel>{t("RELIGION")} : </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          getLabelFor(userInfo?.religion, religionObjArr)
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="receive_notification">
                      <Form.ControlLabel>
                        {t("RECEIVE_NOTIFICATION")} :{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {userInfo?.receive_notification === onOffArr.on
                          ? t("YES")
                          : t("NO")}
                      </Form.ControlLabel>
                    </Form.Group>

                    <h5 className="text-center">
                      {t("ADDRESS")} ({t("PRIMARY")})
                    </h5>
                    <Form.Group controlId="house_no">
                      <Form.ControlLabel>{t("HOUSE_NO")}</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${address?.house_no}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="building">
                      <Form.ControlLabel>{t("BUILDING")}</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${address?.building_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="landmark">
                      <Form.ControlLabel>{t("LANDMARK")}</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${address?.landmark}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="area_name">
                      <Form.ControlLabel>{t("AREA")}</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${address?.area_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="address_mobile">
                      <Form.ControlLabel>
                        {t("ADDRESS_MOBILE")}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${address?.mobile}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="pincode">
                      <Form.ControlLabel>{t("PINCODE")}</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${address?.pincode}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="city_id">
                      <Form.ControlLabel>{t("CITY")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${address?.city?.city_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="state_id">
                      <Form.ControlLabel>{t("STATE")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${address?.state?.state_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="country_id">
                      <Form.ControlLabel>{t("COUNTRY")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${address?.country?.country_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                  </Form>
                </Content>
              ) : null}
            </Container>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewProfileModal;
